<script>
import appConfig from '@src/app.config.json'
import Axios from 'axios'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import ButtonSliding from '@components/ui/button-slides.vue'
import Card from '@components/ui/cards/_base-card.vue'
import NewsCard from '@components/ui/cards/news-card.vue'
import DirectoryCard from '@components/ui/cards/directory-card.vue'
import DataCenterCard from '@components/ui/cards/data-center-card.vue'
import SearchInput from '@components/ui/search-input.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// import debounce from 'lodash/debounce'

// import design from '@design'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: this.pageMeta,
    }
  },
  components: {
    Layout,
    Hero,
    ButtonSliding,
    Card,
    Swiper,
    SwiperSlide,
    NewsCard,
    DirectoryCard,
    DataCenterCard,
    SearchInput,
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    excerpt: function(text, limit) {
      const string = text
        .split(/\s+/)
        .slice(0, limit)
        .join(' ')
      const dots = text.split(' ').length > 10 ? '...' : ''
      return string + dots
    },
  },
  data() {
    return {
      AppSettings: '',
      selectedDataCenter: null,
      activeDataCenter: 'laws-and-regulations',
      activeSlide: {
        infographicRef: 0,
        newsRef: 0,
        academicJournalRef: 0,
      },
      activeHeroSlide: 0,
      slides: 11,
      heroSlides: 3,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 25,
        initialSlide: 0,
        touchRatio: 0,
        // centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperHero: {
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      glossaryCardHeight: undefined,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** for SEO, meta and hero */
      pageTitle: 'Loading...',
      pageDescription: '',
      pageMeta: [],
      /**
       * For Subscribe
       */
      subscribe: {
        title: '',
        atribut: {
          language_source: {
            content: localStorage.getItem('lang')
              ? localStorage.getItem('lang')
              : 'id',
          },
        },
      },
      subscribeStatus: localStorage.getItem('subscribeState')
        ? localStorage.getItem('subscribeState')
        : null,
      isMobile: false,
      /**
       * EACH DATA
       */
      Directories: [],
      Glossary: [],
      Infographics: [],
      News: [],
      AcademicJournals: [],
      Faq: [],
      Slider: [],
      sliderLoading: true,
      LegalAnalysisCategories: [],
      LegalAnalysis: [],
      noData: false,
    }
  },
  computed: {
    cardHeight() {
      return {
        '--glossaryCardHeight': this.glossaryCardHeight + 1 + 'px',
      }
    },
  },
  async mounted() {
    await this.getKlaster('slider', 6)
    if (this.lang === 'id') {
      await this.getLegalAnalysis({ taxonomy: { featured: 252 } })
    } else {
      await this.getLegalAnalysis({ taxonomy: { featured: 254 } })
    }
    await this.getLegalAnalysisCategories()
    /**
     * Load data center from
     */
    await this.getDataCenter(this.activeDataCenter)
    /** get each klaster used for homepage */
    await this.getKlaster('directories', 3)
    await this.getKlaster('glossary', 5)
    await this.getKlaster('infographics', 3)
    await this.getKlaster('news', 6)
    await this.getKlaster('academic-journals', 4)

    this.swiperOption.slidesPerView = 2
    if (this.checkMobile()) {
      this.swiperOption.slidesPerView = 1
    }

    /** FOR SEO and META tag */
    this.pageTitle = this.lang === 'id' ? 'Beranda' : 'Home'
    this.pageDescription = appConfig.pageDescription
    this.pageMeta = [
      {
        name: 'description',
        content: appConfig.pageDescription,
      },
      // facebook
      {
        property: 'og:type',
        content: 'article',
      },
      {
        property: 'og:title',
        content: appConfig.title,
      },
      {
        property: 'og:description',
        content: appConfig.pageDescription,
      },
      {
        property: 'og:url',
        content: this.currentUrl,
      },
      {
        property: 'og:site_name',
        content: appConfig.title,
      },
      // twitter
      {
        name: 'twitter:title',
        content: appConfig.title,
      },
      {
        name: 'twitter:description',
        content: appConfig.pageDescription,
      },
      {
        name: 'twitter:site',
        content: this.currentUrl,
      },
    ]
  },
  methods: {
    getDataCenter(key) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: key,
        simple: true,
        lang: this.lang,
        limit: 4,
        order: 'DESC',
        order_by: 'created_at',
      }
      /** params need to encoded from object to url params */
      params = Object.keys(params)
        .map(function(key) {
          return key + '=' + params[key]
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      /**
       * Do API Request
       */
      Axios.get(endpoint, getOptions).then((response) => {
        this.activeDataCenter = key
        if (response.data.data_total > 0) {
          this.selectedDataCenter = response.data.data
          this.noData = false
        } else {
          this.selectedDataCenter = []
          this.noData = true
        }
      })
    },
    getKlaster(klasterSlug, limit) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: klasterSlug,
        simple: true,
        lang: this.lang,
        order: 'DESC',
        order_by: 'created_at',
        limit: limit,
      }
      /** params need to encoded from object to url params */
      params = Object.keys(params)
        .map(function(key) {
          return key + '=' + params[key]
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      /**
       * Do API Request
       */
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data
        // console.log(endpoint)
        if (data) {
          /** remove - and capitalize after */
          var changeString = klasterSlug.replace(/(^|-)./g, function(s) {
            return s.slice(-1).toUpperCase()
          })
          if (changeString === 'Slider') {
            this.sliderLoading = false
          } else if (changeString === 'Directories') {
            setTimeout(() => {
              this.glossaryCardHeight = this.$refs.directoryContent.clientHeight
            }, 500)
          }
          this[changeString] = data
        }
      })
    },
    getLegalAnalysis: function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'legal-analysis',
        simple: true,
        order: 'DESC',
        order_by: 'created_at',
        lang: this.lang,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param, 'taxonomy', false)
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      // console.log(endpoint)
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      // get the news
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (response.data) {
          this.LegalAnalysis = data
        }
      })
    },
    getLegalAnalysisCategories: function() {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'legal-analysis',
        simple: true,
        taksonomi_slug: this.lang === 'en' ? 'category-en' : 'category',
      }
      /** params need to encoded from object to url params */
      params = Object.keys(params)
        .map(function(key) {
          return key + '=' + params[key]
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-taksonomi?${params}`
      // get the news
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (data) {
          this.LegalAnalysisCategories = data
        }
      })
    },
    subscribes: function(evt) {
      evt.preventDefault()
      var dataToPush = JSON.stringify([this.subscribe])
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      Axios.post(
        `${appConfig.endpoint}/klaster-by-member-record-add/newsletter-subscription`,
        dataToPush,
        getOptions
      ).then(
        (response) => {
          // console.log(response.status)
          if (response.status === 200) {
            this.subscribeStatus = this.subscribe.title
            this.subscribe.title = ''
            localStorage.setItem('subscribeState', this.subscribe.title)
          }
        },
        (error) => {
          console.log(error)
          this.subscribeStatus = error
        }
      )
    },
    newSubscribe: function() {
      localStorage.removeItem('subscribeState')
      this.subscribeStatus = null
    },
    getImgUrl(pic) {
      return require('@assets/images/' + pic)
    },
    nextSlide(ref) {
      this.activeSlide[ref] += 1
      this.$refs[ref].$swiper.slideNext()
    },
    prevSlide(ref) {
      // console.log(this.activeSlide)
      this.activeSlide[ref] -= 1
      this.$refs[ref].$swiper.slidePrev()
    },
    nextHero() {
      this.activeHeroSlide += 1
      this.$refs.heroRef.$swiper.slideNext()
    },
    prevHero() {
      this.activeHeroSlide -= 1
      this.$refs.heroRef.$swiper.slidePrev()
    },
    calculateHeight() {
      this.glossaryCardHeight = this.$refs.directoryContent.clientHeight
    },
    /** check if its mobile or not */
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    /**
     * Push 'TO' url
     */
    to: function(url, type = 'internal') {
      if (type === 'internal') {
        this.$router.push({
          path: url,
        })
      } else {
        window.open(url, '_blank')
      }
    },
    /**
     * It should be filters, but method is also works
     */
    s3: function(path) {
      return appConfig.s3_endpoint + path
    },
    /**
     * Render category name
     */
    renderCategory: function(Obj, type = 'title') {
      if (this.lang === 'en') {
        if (Obj.length !== 0 && Obj.category_en && Obj.category_en.data[0]) {
          return Obj.category_en.data[0][type] + '/'
        } else {
          return ''
        }
      } else {
        if (Obj.length !== 0 && Obj.category.data[0]) {
          return Obj.category.data[0][type] + '/'
        } else {
          return ''
        }
      }
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    excerpt: function(text, limit) {
      const string = text
        .split(/\s+/)
        .slice(0, limit)
        .join(' ')
      const dots = text.split(' ').length > 10 ? '...' : ''
      return string + dots
    },
    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
  },
}
</script>

<template>
  <Layout>
    <Swiper
      ref="heroRef"
      class="swiper"
      :options="swiperHero"
      style="min-height: 35rem"
    >
      <div v-show="sliderLoading" class="w-100">
        <b-skeleton height="35rem"></b-skeleton>
      </div>
      <SwiperSlide
        v-for="(item, index) in LegalAnalysis"
        v-show="sliderLoading === false"
        :key="index"
        class="swiperSlide"
      >
        <Hero
          height="35rem"
          gradient="#1A1A1A"
          :background="
            item.atribut.length !== 0 &&
            item.atribut.slider_image.data.length !== 0
              ? s3(item.atribut.slider_image.data[0].content)
              : ''
          "
        >
          <b-container class="h-100">
            <b-row class="h-100 align-items-center">
              <div class="col-lg-7">
                <router-link
                  :to="
                    '/legal-analysis/' +
                      item.slug +
                      '/' +
                      renderCategory(item.taksonomi) +
                      renderCategory(item.taksonomi, 'ktaksonomi_record_id')
                  "
                  style="font-size: 2rem;font-weight:bold;color:#fff;text-decoration:none;opacity:.95"
                >
                  {{ item.title }}
                </router-link>
                <p
                  class="mt-3 mb-4"
                  :style="{
                    color: '#fff',
                    fontSize: '1.2rem',
                    fontWeight: '300',
                  }"
                  >{{ item.content | plainText | excerpt(25) }}</p
                >
                <!-- eslint-disable -->
                <router-link
                  class="btn btn-primary text-white"
                  :to="
                    '/legal-analysis/' +
                      item.slug +
                      '/' +
                      renderCategory(item.taksonomi) +
                      renderCategory(item.taksonomi, 'ktaksonomi_record_id')
                  "
                >
                  {{ $t('view_more') }}
                </router-link>

                <!-- eslint-enable -->
              </div>
            </b-row>
          </b-container>
        </Hero>
      </SwiperSlide>

      <div slot="pagination" class="swiper-pagination heroPagination"></div>
      <div
        v-if="Slider.data_total > 1"
        slot="button-next"
        class="nextButton hero"
        :style="{
          opacity: activeHeroSlide < Slider.data_total - 1 ? '1' : '.5',
        }"
        @click="nextHero"
      ></div>
      <div
        v-if="Slider.data_total > 1"
        slot="button-prev"
        class="prevButton hero"
        :style="{ opacity: activeHeroSlide > 0 ? '1' : '.5' }"
        @click="prevHero"
      ></div>
    </Swiper>

    <!-- Legal Analysis Section -->
    <section :id="$style.legalAnalysis" class="py-5">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div
            v-if="LegalAnalysis.info"
            class="col-lg-7"
            :class="$style.contentHeader"
          >
            <h1 class="mb-4">{{ LegalAnalysis.info[`${lang} `][0] }}</h1>
            <!-- <span>{{ LegalAnalysis.info[`${lang} `][1] }}</span> -->
          </div>
          <div :class="$style.content">
            <div
              v-for="(item, index) in LegalAnalysisCategories"
              :key="index"
              :class="$style.each"
            >
              <b-card v-if="item.atribut.length !== 0" :class="$style.card">
                <router-link
                  pointer
                  :to="
                    `/legal-analysis?catID=${item.ID}&cat=${item.title}&ref=${$style.legalAnalysis}`
                  "
                  style="text-decoration:none"
                >
                  <img
                    v-for="(icon, i) in item.atribut"
                    :key="i"
                    v-lazy="s3(icon.data[0].content)"
                    alt="icon"
                  />
                  <b-card-text :class="$style.cardContent">{{
                    item.title
                  }}</b-card-text>
                </router-link>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Data Center Section -->
    <section
      :id="$style.dataCenter"
      :style="{
        'background-image':
          'url(' + getImgUrl('demo/Background_Data_Center.jpg') + ')',
      }"
      class="py-5"
    >
      <div class="container">
        <div class="row text-center">
          <div class="col-12" :class="$style.contentHeader">
            <h1>{{ $t('Data Center') }}</h1>
          </div>
          <div class="row" :class="$style.picker">
            <div class="col-lg-4 col-sm-12 mb-sm-0 mb-3">
              <ButtonSliding
                :text="$t('Laws and Regulation')"
                background-color="#1b3665"
                type="light"
                :class="{
                  active: activeDataCenter === 'laws-and-regulations',
                }"
                @click.native="getDataCenter('laws-and-regulations')"
              >
              </ButtonSliding>
            </div>
            <div class="col-lg-4 col-sm-12 mb-sm-0 mb-3">
              <ButtonSliding
                :text="$t('Court Decisions')"
                background-color="#2980b9"
                type="light"
                :class="{ active: activeDataCenter === 'court-decisions' }"
                @click.native="getDataCenter('court-decisions')"
              >
              </ButtonSliding>
            </div>
            <div class="col-lg-4 col-sm-12 mb-sm-0 mb-3">
              <ButtonSliding
                :text="$t('International Conventions')"
                background-color="#f6921e"
                type="light"
                :class="{
                  active: activeDataCenter === 'international-conventions',
                }"
                @click.native="getDataCenter('international-conventions')"
              >
              </ButtonSliding>
            </div>
          </div>
          <div class="row w-100 ml-0">
            <div
              v-for="(item, index) in selectedDataCenter"
              :key="index"
              class="col-lg-6 d-flex align-items-stretch"
            >
              <DataCenterCard
                :title="item.title"
                heading-tag="a"
                style="width:100%"
                :url="
                  `/data-center/${activeDataCenter}/${item.slug}?ref=${$style.dataCenter}`
                "
              >
                <span
                  v-if="
                    item.atribut.caption.data.length !== 0 &&
                      item.atribut.caption.data[0].content
                  "
                >
                  {{
                    capitalize(item.atribut.caption.data[0].content) | plainText
                  }}
                </span>
                <span v-else>
                  {{ capitalize(item.content) | plainText | excerpt(20) }}
                </span>
              </DataCenterCard>
            </div>
            <b-col v-if="noData" cols="lg-12">
              <span class="text-white">{{ $t('No data') }}</span>
            </b-col>
            <div v-if="!noData" class="col-12 text-center">
              <b-button
                variant="dark"
                :to="'/' + $t('data-center') + `?ref=${$style.dataCenter}`"
                class="px-4 py-2 my-4 text-white"
                >{{ $t('view_more') }}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section :id="$style.newsAndUpdates" class="py-5">
      <div class="w-100">
        <b-row class="m-0">
          <b-col
            v-if="News.info"
            cols="12"
            class="text-center"
            :class="$style.contentHeader"
          >
            <h1>{{ News.info[`${lang} `][0] }}</h1>
          </b-col>
        </b-row>
        <b-row class="mx-0 my-5">
          <Swiper
            ref="newsRef"
            class="swiper container px-4"
            :options="swiperOption"
          >
            <SwiperSlide
              v-for="(item, index) in News.data"
              :key="index"
              class="swiperSlide"
            >
              <NewsCard
                :title="item.title"
                :content="
                  item.atribut.caption.data.length !== 0 &&
                  item.atribut.caption.data[0].content
                    ? plainText(item.atribut.caption.data[0].content)
                    : plainText(excerpt(item.content, 40))
                "
                :url="
                  '/' +
                    $t('news') +
                    `/${item.slug}?ref=${$style.newsAndUpdates}`
                "
              >
              </NewsCard>
            </SwiperSlide>
            <div
              v-if="activeSlide.newsRef < 4 - (isMobile ? 1 : 2)"
              slot="button-next"
              class="nextButton"
              @click="nextSlide('newsRef')"
            ></div>
            <div
              v-if="activeSlide.newsRef > 0"
              slot="button-prev"
              class="prevButton"
              @click="prevSlide('newsRef')"
            ></div>
          </Swiper>
          <b-col
            v-if="News.data && News.data.length === 0"
            cols="12"
            class="text-center"
          >
            {{ $t('No data') }}
          </b-col>
        </b-row>
        <b-row v-if="News.data && News.data.length !== 0" class="mx-0 px-0">
          <b-col class="text-center">
            <router-link
              class="btn btn-primary px-4 py-2 my-4 text-white"
              :to="'/' + $t('news') + `?ref=${$style.newsAndUpdates}`"
            >
              {{ $t('view_more') }}
            </router-link>
          </b-col>
        </b-row>
      </div>
    </section>

    <!-- Infographic section -->
    <section :id="$style.infographic" class="py-5 my-4">
      <b-container>
        <b-row>
          <b-col
            v-if="Infographics.info"
            cols="12"
            class="text-center"
            :class="$style.contentHeader"
          >
            <h1>{{ Infographics.info[`${lang} `][0] }}</h1>
          </b-col>
        </b-row>
        <!-- Contents -->
        <b-row v-if="!isMobile" class="my-5 px-3 px-lg-0">
          <div
            v-for="(infographic, index) in Infographics.data"
            :key="index"
            :style="{ display: 'contents' }"
          >
            <b-col cols="lg-4">
              <Card
                v-if="infographic.atribut"
                content-no-border="true"
                border-color="rgba(0,0,0,.25)"
                radius="10px"
                :img-src="
                  infographic.atribut.featured_image.data.length !== 0
                    ? s3(infographic.atribut.featured_image.data[0].content)
                    : ''
                "
                img-height="30rem"
                img-object-fit="contain"
                pointer
                @click.native="to(`/infographic/${infographic.slug}`)"
              >
                <router-link
                  :to="
                    `/infographic/${infographic.slug}?ref=${$style.infographic}`
                  "
                  :style="{
                    color: '#2980B9',
                    textDecoration: 'none',
                    fontSize: '1.5rem',
                  }"
                  >{{ infographic.title }}</router-link
                >
              </Card>
            </b-col>
          </div>
        </b-row>
        <b-row v-if="isMobile" class="mx-0 my-5">
          <Swiper
            ref="infographicRef"
            class="swiper container px-4"
            :options="swiperOption"
          >
            <SwiperSlide
              v-for="(item, index) in Infographics.data"
              :key="index"
              class="swiperSlide"
            >
              <NewsCard
                :title="item.title"
                :img-src="
                  item.atribut.featured_image.data.length !== 0
                    ? s3(item.atribut.featured_image.data[0].content)
                    : ''
                "
                :content="item.content | plainText | excerpt(20)"
                :url="`/infographic/${item.slug}?ref=${$style.infographic}`"
              >
              </NewsCard>
            </SwiperSlide>
            <div
              v-if="activeSlide.infographicRef < 3 - (isMobile ? 1 : 2)"
              slot="button-next"
              class="nextButton"
              @click="nextSlide('infographicRef')"
            ></div>
            <div
              v-if="activeSlide.infographicRef > 0"
              slot="button-prev"
              class="prevButton"
              @click="prevSlide('infographicRef')"
            ></div>
          </Swiper>
        </b-row>
        <b-row>
          <b-col v-if="Infographics.info" cols="12" class="text-center">
            <b-button
              variant="dark"
              :to="'/' + 'infographic' + `?ref=${$style.infographic}`"
              class="px-4 py-2 my-4 text-white"
              >{{ $t('view_more') }}</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- Academic Journal -->
    <section :id="$style.academicJournal" class="py-5 my-4">
      <b-container>
        <b-row class="justify-content-center">
          <b-col
            v-if="AcademicJournals.info"
            cols="lg-7"
            class="text-center"
            :class="$style.contentHeader"
          >
            <h1>{{ AcademicJournals.info[`${lang} `][0] }}</h1>
            <!-- <p>{{ AcademicJournals.info[`${lang} `][1] }}</p> -->
          </b-col>
        </b-row>
        <!-- Contents -->
        <b-row
          v-if="AcademicJournals.data && !isMobile"
          class="my-5 px-3 px-lg-0"
        >
          <b-col
            v-for="(item, index) in AcademicJournals.data"
            :key="index"
            cols="lg-6 mb-3"
            class="d-flex align-items-stretch"
          >
            <Card
              tag="article"
              border="none"
              box-shadow="2px 2px 10px rgba(0,0,0,.1)"
              radius="10px"
              heading-tag="h4"
              img-height="15rem"
              width="100%"
              height="stretch"
            >
              <div style="padding: 1rem">
                <router-link
                  :style="{
                    color: 'var(--primary)',
                    fontWeight: 500,
                    fontSize: '1.5rem',
                    textDecoration: 'none',
                  }"
                  :title="item.title"
                  :to="
                    `/academic-journal/${item.slug}?ref=${$style.academicJournal}`
                  "
                >
                  {{ item.title | capitalize | excerpt(10) }}</router-link
                >
                <div
                  v-if="
                    item.atribut.caption.data.length !== 0 &&
                      item.atribut.caption.data[0].content
                  "
                  >{{ item.atribut.caption.data[0].content | plainText }}</div
                >
                <div v-else>
                  {{ item.content | plainText | excerpt(30) }}
                </div>
              </div>
            </Card>
          </b-col>
          <b-col
            v-if="AcademicJournals.data && AcademicJournals.data.length === 0"
            cols="12"
            class="text-center"
          >
            {{ $t('No data') }}
          </b-col>
        </b-row>
        <b-row v-if="isMobile" class="mx-0 my-5">
          <Swiper
            ref="academicJournalRef"
            class="swiper container px-4"
            :options="swiperOption"
          >
            <SwiperSlide
              v-for="(item, index) in AcademicJournals.data"
              :key="index"
              class="swiperSlide"
            >
              <NewsCard
                :title="item.title"
                :content="item.content | plainText | excerpt(20)"
                :url="
                  `/academic-journal/${item.slug}?ref=${$style.academicJournal}`
                "
              >
              </NewsCard>
            </SwiperSlide>
            <div
              v-if="activeSlide.academicJournalRef < 6 - (isMobile ? 1 : 2)"
              slot="button-next"
              class="nextButton"
              @click="nextSlide('academicJournalRef')"
            ></div>
            <div
              v-if="activeSlide.academicJournalRef > 0"
              slot="button-prev"
              class="prevButton"
              @click="prevSlide('academicJournalRef')"
            ></div>
          </Swiper>
        </b-row>
        <b-row
          v-if="AcademicJournals.data && AcademicJournals.data.length !== 0"
          class="mx-0 px-0"
        >
          <b-col class="text-center">
            <b-button
              v-if="AcademicJournals.info"
              variant="primary"
              class="px-4 py-2 my-4 text-white"
              :to="'/' + 'academic-journal' + `?ref=${$style.academicJournal}`"
              >{{ $t('view_more') }}</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section :id="$style.directory" class="py-5">
      <b-container>
        <b-row>
          <b-col cols="lg-6">
            <div v-if="Directories.info" :class="$style.contentHeader">
              <h1>{{ Directories.info[`${lang} `][0] }}</h1>
            </div>
            <div :class="$style.directoryContent">
              <div ref="directoryContent">
                <div
                  v-for="(directory, index) in Directories.data"
                  :key="index"
                  :class="$style.eachContent"
                >
                  <!-- eslint-disable -->
                  <DirectoryCard
                    v-if="directory.atribut"
                    :title="directory.title"
                    :img-src="
                      directory.atribut.featured_image.data.length !== 0
                        ? directory.atribut.featured_image.data[0].content
                        : ''
                    "
                    :location="
                      directory.atribut.location.data.length !== 0
                        ? directory.atribut.location.data[0].content
                        : ''
                    "
                    :website="
                      directory.atribut.link_website.data.length !== 0
                        ? directory.atribut.link_website.data[0].content
                        : ''
                    "
                    pointer
                    :new-tab="true"
                    @click.native="
                      to(
                        `/directories/${directory.slug}?ref=${$style.directory}`
                      )
                    "
                  ></DirectoryCard>
                  <!-- eslint-enable -->
                </div>
              </div>
              <router-link
                class="btn btn-primary text-white px-4 py-2 mt-5"
                :to="'/' + $t('directories') + `?ref=${$style.directory}`"
                >{{ $t('view_more') }}</router-link
              >
            </div>
          </b-col>

          <b-col cols="lg-6">
            <div v-if="Glossary.info" :class="$style.contentHeader">
              <h1 class="text-dark">{{ Glossary.info[`${lang} `][0] }}</h1>
            </div>
            <div
              :class="$style.glossaryContent"
              class="align-items-stretch"
              :style="[cardHeight]"
            >
              <b-card :class="$style.glossaryCard">
                <div v-for="(item, index) in Glossary.data" :key="index">
                  <div v-if="item.atribut" :class="$style.glossaries">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.content | plainText }}</p>
                  </div>
                </div>
              </b-card>
              <router-link
                class="btn btn-dark text-white px-4 py-2 mt-5"
                :to="'/' + $t('glossary') + `?ref=${$style.directory}`"
                >{{ $t('view_more') }}</router-link
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section :id="$style.faq" class="py-5">
      <b-container>
        <b-row class="justify-content-center px-3">
          <div :class="$style.contentHeader">
            <h1 class="mb-2">{{ $t('Subscribe to Our Newsletter') }}</h1>
          </div>
          <!-- disuruh a ntis buat disable -->
          <b-col v-if="false" cols="12">
            <SearchInput></SearchInput>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form class="row" @submit="subscribes">
              <div class="col-12">
                <b-alert
                  v-if="subscribeStatus !== null"
                  variant="success"
                  show
                  dismissible
                >
                  <!-- eslint-disable -->
                  {{
                    $t(
                      'Thank you, your email address has been added to the list of recipients of our free newsletter.'
                    )
                  }}
                  <!-- eslint-enable -->
                </b-alert>
                <b-form-input
                  v-model="subscribe.title"
                  type="email"
                  :placeholder="$t('Your Email Address')"
                  :style="{
                    borderRadius: '10px',
                    padding: '1.75rem 1rem',
                    color: 'gray',
                  }"
                ></b-form-input>
              </div>
              <div class="col-12 text-center mt-4">
                <b-button variant="dark" class="px-4 py-2" type="submit">
                  {{ $t('Subscribe') }}
                </b-button>
                <!-- <small
                  v-if="subscribeStatus !== null"
                  class="d-block text-muted mt-3"
                  pointer
                  @click="newSubscribe"
                  >{{ $t('Subscribe another') }}</small
                > -->
              </div>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </Layout>
</template>

<style lang="scss" scoped module>
@import '@design';
#legalAnalysis {
  .contentHeader {
    h1 {
      @extend %typography-xxlarge;

      color: $primary;
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 1rem 0;
    margin: 2rem 0;
    .each {
      flex-basis: calc(100% / 5);
      padding: 0.25rem;
      .card {
        border: none;
        img {
          width: 50%;
        }
        .cardContent {
          padding: 1rem 0;
          font-weight: $semi-bold;
          color: #787878;
        }
        &:hover {
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
          transition: all 0.2s ease-in-out;
        }
      }
    }

    /**
    * For: iPhone 6/7/8 Plus and non-Plus Series, iPhone X and most Modern Devices
    */
    @media only screen and (min-width: 300px) and (max-width: 500px) {
      .each {
        flex-basis: calc(100% / 2);
      }
    }
  }
}

#dataCenter {
  // background-color: rgba(41, 128, 185, 0.75);
  .contentHeader {
    h1 {
      @extend %typography-xxlarge;

      margin: 1rem auto;
      color: $white;
    }
  }

  .picker {
    width: 100%;
    margin: 2.5rem 0;
  }
}

#infographic,
#subscribeBox {
  .contentHeader {
    h1 {
      @extend %typography-xxlarge;

      margin: 1rem auto;
      color: $primary;
    }
  }
}

#academicJournal,
#newsAndUpdates {
  background-color: #f7f7f7;
  .contentHeader {
    h1 {
      @extend %typography-xxlarge;

      margin: 1rem auto;
      color: $primary;
    }
  }
}

#directory {
  .contentHeader {
    margin-bottom: 3rem;
    h1 {
      @extend %typography-xxlarge;

      color: $primary;
    }
  }
  .directoryContent {
    .eachContent {
      margin-bottom: 1.5rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .glossaryContent {
    .glossaryCard {
      height: var(--glossaryCardHeight);
      padding: 2rem;
      border-radius: $radius;
      [class~='card-body'] {
        display: flex;
        flex-direction: column;
        .glossaries {
          margin-bottom: 1.5rem;
          h3 {
            color: $dark;
          }
        }
      }
    }
  }
}

#faq {
  position: relative;
  min-height: 20rem;
  background-color: $primary;
  &::before {
    position: absolute;
    top: 25%;
    left: 50%;
    width: 60%;
    height: 60%;
    content: '';
    background-image: url('../../assets/images/decor/Dekor_FAQ.png');
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0.1;
    transform: translate(-50%);
  }
  .contentHeader {
    margin-bottom: 3rem;
    h1 {
      @extend %typography-xxlarge;

      color: $white;
    }
  }
  .faqList {
    padding-left: 0;
    li {
      margin: 1rem 0;
      list-style: none;
      a {
        font-size: 1.5em;
        color: $white;
      }
    }
  }
}

@media only screen and (max-width: $mobile-sm) {
  #directory {
    .glossaryContent {
      .glossaryCard {
        height: auto;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.swiperSlide {
  display: flex;
  align-items: stretch;
  width: calc(50% - 0.5rem);
}
.heroPagination {
  bottom: 3rem;
  left: 50%;
  transform: translate(-50%);
}
.nextButton {
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 1;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  background-color: #2980b9;
  border-radius: 50%;
  transform: translateY(-50%) rotate(180deg);
  &.hero {
    top: 45%;
    right: 2rem;
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    &::after {
      width: 8px;
      height: 10px;
      filter: brightness(0);
    }
  }
  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 16px;
    height: 20px;
    margin-right: 5px;
    content: '';
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAABC0lEQVRYR82YvQ3CMBCFXywKKhfswByUDMAW7MMWDEDJHOxAkYoChYcsgWRZDk6c8x1Z4L58985/HQw/kuws6pO8AtiF2qoAJNcAHvFPqwEE3TnbzQHGCn9hmgEMw3Byzh1LGRMHILkC8CwVbmKgpLtZBki+aidqUQtI7gFcpuoWNVCjWwRAqvDsEJK8Adgu0V1loO/7jff+Ll14kgFp3ZMNaBTOGiB5BnBopXvUQG6b1ILoNHX/p4GYyiwDqRrNtvzcjDRAiruh6UqY5MNmL2idj2ILxhYkqXxUAwQw0xNRkg+bM6FEPha1IJcP03tBDGR2M5rbFvEWzB1bNYDP2Nq9DyRja/NCksvHG30rk5LPWDXmAAAAAElFTkSuQmCC')
      no-repeat 0 0;
    background-size: 100%;
    transform: translate(-70%, -50%);
  }
}
.prevButton {
  position: absolute;
  top: 51%;
  left: 0;
  z-index: 1;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  background-color: #2980b9;
  border-radius: 50%;
  transform: translateY(-50%);
  &.hero {
    top: 46%;
    left: 2rem;
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    &::after {
      width: 8px;
      height: 10px;
      filter: brightness(0);
    }
  }
  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 16px;
    height: 20px;
    margin-right: 5px;
    content: '';
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAABC0lEQVRYR82YvQ3CMBCFXywKKhfswByUDMAW7MMWDEDJHOxAkYoChYcsgWRZDk6c8x1Z4L58985/HQw/kuws6pO8AtiF2qoAJNcAHvFPqwEE3TnbzQHGCn9hmgEMw3Byzh1LGRMHILkC8CwVbmKgpLtZBki+aidqUQtI7gFcpuoWNVCjWwRAqvDsEJK8Adgu0V1loO/7jff+Ll14kgFp3ZMNaBTOGiB5BnBopXvUQG6b1ILoNHX/p4GYyiwDqRrNtvzcjDRAiruh6UqY5MNmL2idj2ILxhYkqXxUAwQw0xNRkg+bM6FEPha1IJcP03tBDGR2M5rbFvEWzB1bNYDP2Nq9DyRja/NCksvHG30rk5LPWDXmAAAAAElFTkSuQmCC')
      no-repeat 0 0;
    background-size: 100%;
    transform: translate(-70%, -45%);
  }
}
@media only screen and (max-width: 600px) {
  .nextButton,
  .prevButton {
    width: 2rem;
    height: 2rem;
    &::after {
      top: 53%;
      left: 53%;
      width: 12px;
      height: 16px;
    }
    &.hero {
      display: none;
    }
  }
  .prevButton {
    left: 0.6rem;
  }
  .nextButton {
    right: 0.6rem;
  }
  .swiperSlide {
    width: calc(100%);
  }
}
</style>
